import React, { useState } from 'react'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import { set } from 'local-storage'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'
import { useUserDispatcher } from '@hooks'
import { useMutation } from '@apollo/client'
import { useHistory } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'
import appClient from '@services'
import { SignInAdminMutation } from '@services/user/mutation'
import { IServiceResponse, ITokenResponse } from '@services/model'
import { MainDiv, FormSignIn, Container } from './style.sc'
import { signInAsync } from '../../services/restAPI/auth/authService'
import { Select } from '@material-ui/core'

const SignIn: React.FC = () => {
    const [userName, setUserName] = React.useState<string>('')
    const [password, setPassword] = React.useState<string>('')
    const [courseId, setCourseId] = useState<string>(`1`)
    const [isLoading, setIsLoading] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState<string>('')
    const [doSignIn] = useMutation(SignInAdminMutation, { client: appClient })
    const history = useHistory()
    const { setTokenAuthData } = useUserDispatcher()

    const signInHandler = async () => {
        setIsLoading(true)
        setErrorMessage('')
        signInAsync({
            courseId: courseId,
            email: userName,
            password: password,
            platform: 'web'
        })
            .then(result => {
                set<string>('token', result.token)
                set<string>('refreshToken', result.refreshToken)
                setTokenAuthData(result.token)
                history.push('/main')
            })
            .catch(err => {
                console.error(err.message)
                setErrorMessage(err.message)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return <MainDiv>
        <Container>
            <h2>PARENTEQUE ADMIN PANEL LOGIN</h2>
            {errorMessage && (<div style={{ marginBottom: 20 }}><Alert variant="filled" severity="error">
                {errorMessage}
            </Alert></div>)}

            <FormSignIn>
                <FormControl style={{ marginBottom: 20 }}>
                    <InputLabel htmlFor="userName">User name</InputLabel>
                    <Input disabled={isLoading} fullWidth type="text" id="userName" aria-describedby="userName" onChange={e => setUserName(e.currentTarget.value)} />
                </FormControl>
                <FormControl style={{ marginBottom: 20 }}>
                    <InputLabel htmlFor="password">Password</InputLabel>
                    <Input disabled={isLoading} fullWidth type="password" id="password" aria-describedby="password" onChange={e => setPassword(e.currentTarget.value)} />
                </FormControl>
                <FormControl fullWidth>
                    {/* <InputLabel htmlFor="courseId">Course</InputLabel> */}
                    <Select
                        native
                        value={courseId}
                        disabled={isLoading}
                        onChange={e => {
                            const val = e.currentTarget.value
                            setCourseId(e.currentTarget.value as any)
                        }}
                        fullWidth
                    >
                        <option value="1">Swim</option>
                        <option value="2">Basketball</option>
                    </Select>
                </FormControl>
                <br />
                <Button disabled={isLoading} variant="contained" color="primary" onClick={e => {
                    e.preventDefault()
                    if (userName == '' || password == '') {
                        setErrorMessage('Please fill all fields first')
                        setIsLoading(false)
                        return
                    }

                    signInHandler()
                }}>
                    {isLoading ? <CircularProgress size={25} style={{ color: '#fff' }} /> : "Login"}
                </Button>
            </FormSignIn>
        </Container>
    </MainDiv>
}

export default SignIn